import React, { useState } from "react";
import { useTranslation } from "../../hooks/useTranslation";

const FAQItem = ({ question, answer, isOpen, onToggle }) => {
  return (
    <div className="faq-item">
      <div className="faq-question" onClick={onToggle}>
        <div className="faq-heading">{question}</div>
        <div className="faq-toggle">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
            }}
          >
            <path
              d={isOpen ? "M18 15L12 9L6 15" : "M18 9L12 15L6 9"}
              stroke="#009B31"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
      {isOpen && answer && <div className="faq-answer">{answer}</div>}
    </div>
  );
};

const FAQSection = ({ faqs, hideHeader = false }) => {
  const { t } = useTranslation("camperDetails");

  const [openItems, setOpenItems] = useState(
    faqs.reduce((acc, faq, index) => {
      acc[index] = faq.isOpen || false;
      return acc;
    }, {}),
  );

  const toggleItem = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="faq-section">
      {!hideHeader && (
        <div className="faq-header">
          <div className="faq-title">{t("faqSection.title")}</div>
          <div className="faq-subtitle">{t("faqSection.subtitle")}</div>
        </div>
      )}
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <FAQItem
            key={index}
            question={faq.question}
            answer={faq.answer}
            isOpen={openItems[index]}
            onToggle={() => toggleItem(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
